export const REQUESTED_BOOK_DETAILS = 'REQUESTED_BOOK_DETAILS';
export const REQUESTED_BOOK_DETAILS_SUCCESS = 'REQUESTED_BOOK_DETAILS_SUCCESS';
export const REQUESTED_BOOK_DETAILS_FAILURE = 'REQUESTED_BOOK_DETAILS_FAILURE';
